import React, { useEffect, useState } from "react";


export default function CountDownCard1() {
  const TARGET = "2026-12-31T23:59:59"; // Set your offer expiry date here

  const getTimeLeft = () => {
    const total = new Date(TARGET) - new Date();
    if (total <= 0) return { d: 0, h: 0, m: 0, s: 0, expired: true };

    return {
      d: Math.floor(total / (1000 * 60 * 60 * 24)),
      h: Math.floor((total / (1000 * 60 * 60)) % 24),
      m: Math.floor((total / (1000 * 60)) % 60),
      s: Math.floor((total / 1000) % 60),
      expired: false
    };
  };

  const [time, setTime] = useState(getTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => setTime(getTimeLeft()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (<>
    <section className="offer-box-cd1">
      <div className="offer-left-cd1">
        <img
          src="https://i.postimg.cc/NjF4BFVz/red_haired_lady_eyeglasses_holds_books_shows_ok_sign_1_removebg_preview.png"
          alt="Pizza"
        />
      </div>

      <div className="offer-right-cd1">
        <span className="offer-tag-cd1">Exclusive Offer</span>
        <h2>Get At 40% Discount</h2>

        <p className="price-cd1">
         ₹ 1000 <span className="old-cd1"> ₹ 600</span>
        </p>

        <p>Available: 20</p>
        <p>Already Sold: 230</p>

        <div className="progress-bar-cd1">
          <span style={{ width: "70%" }}></span>
        </div>

        <div className="countdown-cd1">
          <div><strong>{time.d}</strong><span>Days</span></div>
          <div><strong>{time.h}</strong><span>Hours</span></div>
          <div><strong>{time.m}</strong><span>Mins</span></div>
          <div><strong>{time.s}</strong><span>Secs</span></div>
        </div>

        <button className="explore-btn-cd1">Explore Now</button>
      </div>
    </section>
    <style>{`.offer-box-cd1 {
  background: rgba(144, 202, 249,0.21);
  padding: 40px 30px;
  margin: 40px auto;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  gap: 30px;
}

.offer-left-cd1 img {
  width: 100%;
  max-width: 390px;
  border-radius: 18px;
  object-fit: cover;
}

.offer-right-cd1 {
  flex: 1;
}

.offer-tag-cd1 {
  background: #222;
  color: #fff;
  padding: 6px 14px;
  border-radius: 5px;
  font-size: 14px;
}

.price-cd1 {
  font-size: 22px;
  margin: 10px 0;
}

.price-cd1 .old-cd1 {
  color: #444;
  text-decoration: line-through;
  margin-left: 10px;
}

.progress-bar-cd1 {
  background: #eee;
  height: 6px;
  border-radius: 20px;
  width: 100%;
  margin: 10px 0;
}

.progress-bar-cd1 span {
  background: #222;
  height: 6px;
  display: block; 
  border-radius: 20px;
}

.countdown-cd1 {
  display: flex;
  gap: 12px;
  margin: 18px 0;
}

.countdown-cd1 div {
  background: #222;
  color: #fff;
  width: 65px;
  height: 65px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  font-size: 13px;
}

.countdown-cd1 strong {
  font-size: 20px;
}

.explore-btn-cd1 {
  background: #111;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

@media(max-width: 900px) {
  .offer-box-cd1 {
    flex-direction: column;
    text-align: center;
  }
  .offer-right-cd1 {
    width: 100%;
  }
}
`}</style>
    </>
  );
}
